import { create } from 'apisauce';
import authStore from '../stores/auth-store';

import urlgetter from './getMainUrl';


const api = create({
	baseURL: urlgetter.getMainApiUrl()
});

const func = {};


func.loadPrices = (startdate, endDate) =>{
	// console.log('load price data');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/loadPrices');
}

func.updatePriceSchedule = (id,priceBody) => {
	// console.log('in UpdatePlanes');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/admin/priceSchedule/' + id, priceBody);
}

func.updatePaySchedule = (id,priceBody) => {
	// console.log('in UpdatePlanes');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/admin/paySchedule/' + id, priceBody);
}


func.GetCountersaleDetails = (startdate, endDate, subType) => {
	// console.log('Get Invoice category');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getCountersaleDetails?start='+startdate+'&end='+endDate+"&subType="+subType);
}

func.GetCollectionDetails = (startdate, endDate) => {
	// console.log('Get Invoice category');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getCollectionDetails?start='+startdate+'&end='+endDate);
}


func.LoadTodayTandemReservationSummary = () => {
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/loadTodayTandemReservationSummary');
}

func.GetTandemDetails = (startdate, endDate, subType) => {
	// console.log('Get Invoice category');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getTandemDetails?start='+startdate+'&end='+endDate+"&subType="+subType);
}

func.GetAffDetails = (startdate, endDate) => {
	// console.log('Get Invoice category');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getAffDetails?start='+startdate+'&end='+endDate);
}

func.GetCoachJumpDetails = (startdate, endDate, subType) => {
	// console.log('Get Invoice category');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getCoachDetails?start='+startdate+'&end='+endDate+"&subType="+subType);
}

func.GetFunJumpDetails = (startdate, endDate, subType) => {
	console.log('Get Fun Jump details');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getFunJumpDetails?start='+startdate+'&end='+endDate+"&subType="+subType);
}

func.GetInvoiceByCategory = (startdate, endDate) => {
	// console.log('Get Invoice category');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getInvoiceByCategory?start='+startdate+'&end='+endDate);
}

func.GetSlots = (startdate, endDate) =>{
	// console.log('Get Slots');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getSlots?start='+startdate+'&end='+endDate);
}

func.GetDateOfLastZeroPostedBalance = (id) => {
	
	var token = authStore.getAuthToken();
	
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	
	return api.get('/reports/getDateOfLastZeroPostedBalance/'+id);	
}

func.GetJumperLogs = (startdate, endDate,id) =>{
	// console.log('Get Jumper Logs');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getLocalJumperLogs?start='+startdate+'&end='+endDate +'&jumper='+id);
}

func.GetTodayJumperLogs = (endDate,id) =>{
	// console.log('Get Jumper Logs');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getLocalJumperLogs?end='+endDate +'&jumper='+id);
}

func.GetStaffSummary = (startdate, endDate) => {
	// console.log('Get Staff Summary');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getStaffSummary?start='+startdate+'&end='+endDate);
}

func.getDropzoneTodayActivity = () => {
	// console.log('Get dropzone today activity');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/reports/getDropzoneTodayActivity');
}

export default func;
 